/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const ALLOCATE_PAYMENT_SEARCH_SCREEN = 'ALLOCATE_PAYMENT_SEARCH_SCREEN';
export const PERV_SEARCH_SCREEN_DATA = 'PERV_SEARCH_SCREEN_DATA';
export const PERV_SEARCH_PICK_INV_ASSOCIATE_SCREEN_DATA =
  'PERV_SEARCH_PICK_INV_ASSOCIATE_SCREEN_DATA';
export const ALLOCATE_PAYMENT_SEARCH_PICK_INVOICE_ASSOCIATE_SCREEN =
  'ALLOCATE_PAYMENT_SEARCH_PICK_INVOICE_ASSOCIATE_SCREEN';
export const HANDLE_ERROR_MESSAGE_FOR_ALLOCATE_PAY =
  'HANDLE_ERROR_MESSAGE_FOR_ALLOCATE_PAY';
export const ERROR_MESSAGE_SEARCH_SCREEN = 'ERROR_MESSAGE_SEARCH_SCREEN';
export const GET_CHECK_ALLOCATE_PAYMENT_DETAILS =
  'GET_CHECK_ALLOCATE_PAYMENT_DETAILS';
export const GET_MANUFACTURER_DATA_A_PAYMENT =
  'GET_MANUFACTURER_DATA_A_PAYMENT';
export const GET_QUARTER_DATA_A_PAYMENT = 'GET_QUARTER_DATA_A_PAYMENT';
export const GET_REBATE_PROGRAM_DATA = 'GET_REBATE_PROGRAM_DATA';
export const EXISTING_INVOICE_NUMBER = 'EXISTING_INVOICE_NUMBER';
export const ROSI_PQAS_GIRD_HEADER_DATA = 'ROSI_PQAS_GIRD_HEADER_DATA';
export const ISTR_DEALLOC_DATA = 'ISTR_DEALLOC_DATA';
export const DEALLOCATE_NDC_ROSI = 'DEALLOCATE_NDC_ROSI';
export const ROSI_GRID_DATA = 'ROSI_GRID_DATA';
export const SUMMARY_GRID_DATA = 'SUMMARY_GRID_DATA';
export const GRID_LEVEL_ACTIONS_AP = 'GRID_LEVEL_ACTIONS_AP';
export const GRID_RS_ADD_VALUES = 'GRID_RS_ADD_VALUES';
export const PARTIALLY_PAID_DRUGS = 'PARTIALLY_PAID_DRUGS';
export const ACTIVE_INVOICE_NUM = 'ACTIVE_INVOICE_NUM';
export const FAILED_API_ERR_MSG = 'FAILED_API_ERR_MSG';
export const GET_GENERAL_SYSTEM_PARAMETER_AP =
  'GET_GENERAL_SYSTEM_PARAMETER_AP';
export const GET_DUPLICATE_ROSI_GIRD = 'GET_DUPLICATE_ROSI_GIRD';
export const GET_DECLARE_CHECKALLOCATION = 'GET_DECLARE_CHECKALLOCATION';
export const UPDATE_DETAILS = 'UPDATE_DETAILS';
export const ALLOCATE_PAYMENT_DETAIL_TAB_DATA =
  'ALLOCATE_PAYMENT_DETAIL_TAB_DATA';
export const GET_COMMON_DROPDOWN_AP = 'GET_COMMON_DROPDOWN_AP';
export const DISABLED_INT_PAID_COLUMN_ROSI = 'DISABLED_INT_PAID_COLUMN_ROSI';
export const ROSI_PQAS_GIRD_HEADER_DATA_NOTIFY =
  'ROSI_PQAS_GIRD_HEADER_DATA_NOTIFY';
export const ROSI_PQAS_IS_IDBL_MFG_UB = 'ROSI_PQAS_IS_IDBL_MFG_UB';
export const ACTIVE_ROSI_PQAS_TAB_DETAILS = 'ACTIVE_ROSI_PQAS_TAB_DETAILS';
export const SET_POPUP_ACKNOWLEDGED = 'SET_POPUP_ACKNOWLEDGED';
export const RESET_POPUP_ACKNOWLEDGED = 'RESET_POPUP_ACKNOWLEDGED';
export const SET_POPUP_CANCEL_FLAG = 'SET_POPUP_CANCEL_FLAG';
export const RESET_POPUP_CANCEL_FLAG = 'RESET_POPUP_CANCEL_FLAG';
export const REMOVE_ACTIVE_DETAIL_SCREEN_TAB =
  'REMOVE_ACTIVE_DETAIL_SCREEN_TAB';
export const ROSI_DISC_NDCS = 'ROSI_DISC_NDCS';
export const CURR_ROSI_COL_ID = 'CURR_ROSI_COL_ID';
export const SET_DUPLICATE_ROSI_INTEREST_INDEX =
  'SET_DUPLICATE_ROSI_INTEREST_INDEX';
export const SET_NEW_OLD_ROSI = 'SET_NEW_OLD_ROSI';
export const SAME_DISC_VAL = 'SAME_DISC_VAL';
export const IS_HANDLE_OK_PAY_REM = 'IS_HANDLE_OK_PAY_REM';
